import { app } from '../../../app';

class LicenseManagementService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    licenseCheck(companyId) {
        const url = `app/rest/${companyId}/licensemanagement/license-check`;
        return this.$http.get(url).then(({data}) => data);
    }

    getLicenseDetails(companyId) {
        const url = `app/rest/${companyId}/licensemanagement/license-details`;
        return this.$http.get(url).then(({data}) => data);
    }

    getLicenseTiers(companyId) {
        const url = `app/rest/${companyId}/licensemanagement/license-tiers`;
        return this.$http.get(url).then(({data}) => data);
    }

    licensePurchase(companyId, purchaseDTO) {
        const url = `app/rest/${companyId}/licensemanagement/license-purchase`;
        return this.$http.post(url, purchaseDTO).then(({data}) => data);
    }

}

app.service('LicenseManagementService', LicenseManagementService);



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/license-management.service.js